import { render, staticRenderFns } from "./ExpandButton.vue?vue&type=template&id=f72dea1c&scoped=true&"
import script from "./ExpandButton.vue?vue&type=script&lang=ts&"
export * from "./ExpandButton.vue?vue&type=script&lang=ts&"
import style0 from "./ExpandButton.vue?vue&type=style&index=0&id=f72dea1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72dea1c",
  null
  
)

export default component.exports